import { createContext } from 'react';
import type { StationData } from '../api/stationObservationsService';
import type { TioCurrentWeatherData } from '../api/tomorrowIoTimelineService';

export type WeatherDataSource = 'stations' | 'tio-api';

export interface NormalizedWeatherData {
  temperature: number | null;
  trackTemperature: number | null;
  lightIntensity: number | null;
  wbgt: number | null;
  heatIndex: number | null;
  timestamp: Date | null;
}

export interface StationObservationsContextType {
  // Original station observations
  observations: StationData | null;
  loading: boolean;
  error: string | null;
  
  // Tomorrow.io API data
  tioData: TioCurrentWeatherData | null;
  tioLoading: boolean;
  tioError: string | null;
  tioTimestamp: Date | null;
  
  // Data source selection
  dataSource: WeatherDataSource;
  setDataSource: (source: WeatherDataSource) => void;
  
  // Normalized data for cards (from either source)
  currentWeather: NormalizedWeatherData;
  
  // Is TIO API available (event is active)
  isTioAvailable: boolean;
  
  // Refresh function to refetch current data source
  refresh: () => void;
  refreshing: boolean;
  
  // External stations data (provided by NowcastingPage/ObservationsPage to avoid duplicate API calls)
  setExternalStations: (stations: StationData[] | null) => void;
  // Date range for finding latest observation (set by NowcastingPage/ObservationsPage when using stations)
  setSelectedDateRange: (range: { start: Date; end: Date } | null) => void;
}

export const StationObservationsContext = createContext<StationObservationsContextType | undefined>(undefined);
